import React from 'react';
import { useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import { ClipboardList, Sparkles } from 'lucide-react';
import MyTrainingPlan from './MyTrainingPlan';
import WorkoutWheel from './WorkoutWheel';
import WorkoutWheelSettings from './WorkoutWheelSettings';

const GymMenu: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-theme-secondary pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <h1 className="text-3xl font-bold text-theme-primary mb-2">Gym</h1>
          <p className="text-theme-secondary mb-8">Welcome to the Gym section! Choose a mini app:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl">
            <div
              className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
              onClick={() => navigate('/gym/my-training-plan')}
            >
              <div className="flex items-center justify-between mb-4">
                <ClipboardList className="h-8 w-8 text-theme-primary group-hover:text-green-600 transition-colors" />
              </div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                My Training Plan
              </h3>
              <p className="text-theme-secondary text-sm">
                Multi-day programs, timed workouts, and history
              </p>
            </div>
            <div
              className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
              onClick={() => navigate('/gym/workout-wheel')}
            >
              <div className="flex items-center justify-between mb-4">
                <Sparkles className="h-8 w-8 text-theme-primary group-hover:text-green-600 transition-colors" />
              </div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                Spin the Workout Wheel
              </h3>
              <p className="text-theme-secondary text-sm">
                Random bodyweight mini-workout with tier-colored slices
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const GymSection: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<GymMenu />} />
      <Route path="workout-builder" element={<Navigate to="/gym/my-training-plan" replace />} />
      <Route path="my-training-plan" element={<MyTrainingPlan />} />
      <Route path="workout-wheel" element={<WorkoutWheel />} />
      <Route path="workout-wheel/settings" element={<WorkoutWheelSettings />} />
    </Routes>
  );
};

export default GymSection;
